import React, { useMemo } from 'react'
import MealIngredientCategoryGroceryForm from './_form'

export default function MealIngredientCategoryGroceryAdd (props) {
  const data = useMemo(() => ({ active: false }), [])
  return (
    <MealIngredientCategoryGroceryForm data={data} {...props} />
  )
}